import React, { useState, useLayoutEffect } from "react";
import Header from "../components/Header";
import Sidebar from "./Sidebar";
import '../styles/mobileHeader.css';
// import 'src/styles/sub/mobileHeader.css';

const MobileHeader =({page, waveTransforms, ease}) =>{

    const [width, setWidth] = useState(1);
    const [height, setHeight] = useState(1);

    useLayoutEffect(() => {
        const handleResize = () => {
            if(window != null){
                var height = window.innerHeight;
                var width = window.innerWidth;
                setWidth(width);
                setHeight(height);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            if(window != null){
                window.removeEventListener("resize", handleResize)
            }
        };
    }, []);
    return(
        <div style={{background: '', width: '100%', height: '100px'}}>
            <div style={{position: 'absolute', height: '100px', width: '128px', background: 'transparent', top: '0', left: '0', alignItems: 'center', alignContent: 'center', overflow: 'hidden'}}>
                <h2 style={{position: 'fixed', top: '8px', left: '16px', margin: 'auto', 
                                        backgroundColor: `white`
                                        }} className="poppins-bold headerContentLogo">max</h2>
            </div>
            <Sidebar style={{background: 'purple'}}  scrollButtonCallback={(() => {})}/>

        {/* <div style={{bottom: '0px', width: '100%', height: '350px', position: 'fixed', padding: 0, margin: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0}}>
            <div className={`rock1mob ${ease ? 'moveable' : ''}`} style={{transform: `translate(${0}%, ${waveTransforms[4]}%)`}}/>
            <div className={`${ease ? 'moveable' : ''}`} style={{zIndex: 0, position: 'absolute', width: '100%', height: '100%', transform: `translate(${waveTransforms[1]}%, ${waveTransforms[3]}%)`}}>
                <div className="header-wave-r2 header-wave"/>
                <div className="rock3"/>
                <div className="header-wave-l1 header-wave"/>
                <div className="header-wave-r1 header-wave"/>
            </div>
        </div>             */}
       </div>
    )
}

export default MobileHeader;